import {Component, Element, Host, h, Prop} from '@stencil/core';
import {IconsSizes, IconColors} from '@/types';

@Component({
    tag: 'joy-icon',
    styleUrl: 'style/icon.scss',
    shadow: true,
})
export class Icon {
    private io?: IntersectionObserver;

    @Element() el!: HTMLJoyIconElement;
    /**
     * Defines a non-visible legend
     */
    @Prop({reflect: true}) ariaLabel?: string;
    /**
     * Color change on hover
     */
    @Prop({reflect: true}) clickable = false;
    /**
     * The icon color
     */
    @Prop({reflect: true}) color?: IconColors = 'teal';
    /**
     * The icon custom class(es), if needed
     */
    @Prop({reflect: true}) customClass?: string;
    /**
     * The icon svg filename
     */
    @Prop({reflect: true}) name = 'bell';
    /**
     * The icon size
     */
    @Prop({reflect: true}) size?: IconsSizes;

    get colorClass() {
        return this.color ? {[`joy-icon--${this.color}`]: true} : null;
    }

    get sizeClass() {
        return this.size ? {[`joy-icon--${this.size}`]: true} : null;
    }

    get elementClass() {
        return this.customClass ? {[this.customClass]: true} : null;
    }

    render() {
        return (
            <Host role="img" class={{...this.elementClass, ...this.colorClass}}>
                <div
                    class={{
                        'joy-icon': true,
                        ...this.sizeClass,
                        'joy-icon--clickable': this.clickable,
                    }}
                >
                    <div class="joy-icon-inner">
                        <i
                            class={{
                                icon: true,
                                [`icon-${this.name}`]: true,
                            }}
                        ></i>
                    </div>
                </div>
            </Host>
        );
    }
}
